/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedInvoice: null,
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setSelectedInvoice: (state, action) => {
      state.selectedInvoice = action.payload
    },
  },
})

export const { setSelectedInvoice } = paymentSlice.actions

export default paymentSlice.reducer
